<template>
    <b-container>
    <h1>Recent User Logins</h1>
    <b-table striped hover :items="results">
        <template #cell(date_created)="data">
            {{ data.value | fullDate }}
        </template>
    </b-table>
</b-container>
</template>

<script>
import ReportDataService from '@/services/ReportDataService';

export default {
    data() {
        return {
            results: []
        }
    },
    created() {

        ReportDataService.getRecentLogins().then((res) => {
            this.results = res.data;
        })
    }
}
</script>